let dd_custom_login_customer_id = document.querySelector('.dd_custom_login_customer_id');
let dd_custom_login_error_msg_text = document.querySelector('.dd_custom_login_success_and_error_msg_containor');
let dd_custom_login_user_mobile_number_otp_sec_ele = document.querySelector('.dd_custom_login_user_mobile_number_otp_section');
let dd_custom_login_user_mobile_number_detail_sec_ele = document.querySelector('.dd_customer_info_sec_mobile');
let dd_custom_login_shop_domain = document.querySelector('.dd_custom_login_shop_domain');
let dd_custom_login_otp_input_boxes = document.querySelectorAll(".dd_custom_login_otp_input_box");
let dd_custom_login_popup_overlap = document.querySelector('.dd_custom_login_popup_overlap');
let dd_loading_bar_spinner = document.querySelector('#dd_loading_bar_spinner');
let dd_custom_otp_user_names = document.querySelectorAll('.dd_custom_otp_user_names');
let dd_otp_detail_email_input = document.getElementById("email-id");
let dd_anniversary_input = document.querySelector('.dd_otp_detail_form_anniversary_input')
let dd_dob_input = document.querySelector('.dd_otp_detail_form_dob_input');
let dd_gender_input = document.querySelector('.dd_otp_detail_form_gender_selector');
let dd_marketing_checkbox = document.querySelector('.dd_marketing_option_checkbox');
let dd_new_customer_login_url = '';
let dd_custom_login_user_mobile_number = '';

if(dd_custom_login_customer_id && !dd_custom_login_customer_id.dataset.customer_id){
  let dd_login_containor = document.querySelector('.cst_log_popup_wrapp');
   if(__st.pageurl.includes('account/login')){
       dd_login_containor.classList.remove('dd_hide_custom_login_popup');
       dd_custom_login_popup_overlap.classList.add('dd_hide_custom_login_popup');
       document.body.classList.remove('dd_custom_popup_body_overflow_hidden');
    } 
  
  window.dd_custom_login_show_msg=(dd_msg_text,show_success_msg)=>{
    if(dd_msg_text.includes('Email has already been taken')){
     let dd_error_span_ele = dd_otp_detail_email_input.closest('.login_inputblock').querySelector('.dd_error_msg_detail_form');
     dd_error_span_ele.innerText = dd_msg_text;
     dd_error_span_ele.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    const dd_error_icon = `<div class='d_custom_login_wrong_error_icon'><svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM8.96963 8.96965C9.26252 8.67676 9.73739 8.67676 10.0303 8.96965L12 10.9393L13.9696 8.96967C14.2625 8.67678 14.7374 8.67678 15.0303 8.96967C15.3232 9.26256 15.3232 9.73744 15.0303 10.0303L13.0606 12L15.0303 13.9696C15.3232 14.2625 15.3232 14.7374 15.0303 15.0303C14.7374 15.3232 14.2625 15.3232 13.9696 15.0303L12 13.0607L10.0303 15.0303C9.73742 15.3232 9.26254 15.3232 8.96965 15.0303C8.67676 14.7374 8.67676 14.2625 8.96965 13.9697L10.9393 12L8.96963 10.0303C8.67673 9.73742 8.67673 9.26254 8.96963 8.96965Z" fill="#ffffff"></path> </g></svg></div>`;
    const dd_success_icon = `<div class='d_custom_login_success_icon'><svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="25px" height="25px" viewBox="0 0 52 52"><path d="M26,0C11.664,0,0,11.663,0,26s11.664,26,26,26s26-11.663,26-26S40.336,0,26,0z M26,50C12.767,50,2,39.233,2,26 S12.767,2,26,2s24,10.767,24,24S39.233,50,26,50z"/><path d="M38.252,15.336l-15.369,17.29l-9.259-7.407c-0.43-0.345-1.061-0.274-1.405,0.156c-0.345,0.432-0.275,1.061,0.156,1.406 l10,8C22.559,34.928,22.78,35,23,35c0.276,0,0.551-0.114,0.748-0.336l16-18c0.367-0.412,0.33-1.045-0.083-1.411 C39.251,14.885,38.62,14.922,38.252,15.336z"/></svg></div>`;
    const dd_close_btn_icon = `<div class='d_custom_login_wrong_error_box_close_icon' onclick='dd_custom_login_close_msg(this)'><svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z" fill="#ffffff"></path> </g></svg></div>`;
    const dd_login_error_msg_str = `
    <div class='${show_success_msg ? "dd_custom_login_success_msg_containor" : "dd_custom_login_error_msg_containor"} dd_custom_login_msg'>
      ${show_success_msg ? dd_success_icon : dd_error_icon}
      <div class='d_custom_login_wrong_error_text'>${dd_msg_text}</div>
      ${dd_close_btn_icon}
    </div>`;
 
    dd_custom_login_error_msg_text.innerHTML = dd_login_error_msg_str; 
    setTimeout(() => {dd_custom_login_error_msg_text.innerHTML = ''}, 2000);
  }

  window.dd_custom_login_change_step=(dd_next_step_section_class_to_show)=>{
    let dd_custon_login_step_sections = document.querySelectorAll('.dd_custon_login_step_section');
    dd_custon_login_step_sections.forEach((dd_custon_login_step)=>{
      if(dd_custon_login_step.classList.contains(dd_next_step_section_class_to_show)){
        dd_custon_login_step.classList.remove('dd_custom_login_hidden');
      }else{
        dd_custon_login_step.classList.add('dd_custom_login_hidden');
      }
    }) 
    if(dd_next_step_section_class_to_show == 'dd_custom_login_otp_section'){
      dd_custom_login_show_msg('OTP send successfully',true);
      dd_custom_login_user_mobile_number_otp_sec_ele.innerText = `+91 ${dd_custom_login_user_mobile_number}`;
      document.querySelector(".dd_custom_login_otp_input_box").focus();
      let dd_otp_resend_time_containor = document.querySelector('.dd_otp_resend_time_containor');
      let dd_otp_second_ele = document.querySelector('.dd_otp_resend_time_containor .seconds_box');
      let dd_resend_otp_containor = document.querySelector('.dd_resend_otp_containor');
      dd_otp_resend_time_containor.classList.remove('hide');
      dd_resend_otp_containor.classList.add('hide');
      let dd_second_interval_count = 5;
      let dd_second_interval=setInterval(() => {
        dd_second_interval_count--;
        if(dd_second_interval_count == 0){
           clearInterval(dd_second_interval);
           dd_resend_otp_containor.classList.remove('hide');
           dd_otp_resend_time_containor.classList.add('hide');
        }else{
          dd_otp_second_ele.innerHTML = `0${dd_second_interval_count}`;
        }
      }, 1000);
    }
  }
  async function dd_custom_login_send_otp_fun(phone, shop ,otp_digits) {
    try {
      const res = await fetch("https://api.kalkifashion.com/kalki-api-new/get-customer.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone, shop ,otp_digits})
      });
      const dd_response = await res.json();
      dd_loading_bar_spinner.classList.add('dd_hide_loading');
      if(dd_response.success){
         Array.from(dd_custom_login_otp_input_boxes).map(input => input.value='');
         dd_custom_login_change_step('dd_custom_login_otp_section');
      }else{
        dd_custom_login_show_msg(dd_response.message,false)
      }
    } catch (e) {
      return { success: false, message: e.message };
    }
  }
  window.dd_custom_login_resend_otp=()=>{dd_custom_login_send_otp_fun(`+91${dd_custom_login_user_mobile_number}`,dd_custom_login_shop_domain.dataset.domain,'');}
  window.dd_close_custom_login_popup=()=>{
    if(dd_new_customer_login_url){
       window.location = dd_new_customer_login_url;
    }
    if(!dd_login_containor.classList.contains('dd_hide_custom_login_popup')){
      dd_login_containor.classList.add('dd_hide_custom_login_popup');
        dd_custom_login_popup_overlap.classList.add('dd_hide_custom_login_popup');
        document.body.classList.remove('dd_custom_popup_body_overflow_hidden')
     }
  };
  window.dd_custom_login_close_msg=(dd_msg_remove_icon)=>{dd_msg_remove_icon.closest('.dd_custom_login_msg').remove();}

  window.dd_login_otp_send_event_fun=()=>{
    let dd_custom_login_input_phone = document.querySelector('.dd_custom_login_input_phone');
    let dd_is_error_box_already_open = document.querySelector('.d_custom_login_wrong_error_text');
    if(dd_custom_login_input_phone.value.length!=10){
        if(!dd_is_error_box_already_open){dd_custom_login_show_msg('Please enter valid mobile number',false)}
        return;
    }
    dd_loading_bar_spinner.classList.remove('dd_hide_loading');
    dd_custom_login_user_mobile_number = dd_custom_login_input_phone.value;
    dd_custom_login_send_otp_fun(`+91${dd_custom_login_user_mobile_number}`,dd_custom_login_shop_domain.dataset.domain,'');
  }
 
  async function dd_login_verify_otp_fun(phone, otp,shop,url) {
    try {
      const res = await fetch("https://api.kalkifashion.com/kalki-api-new/verify.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone, otp ,shop,url})
      });
      const data = await res.json();
      dd_loading_bar_spinner.classList.add('dd_hide_loading');
      if(data.success){
        if(data.found){
           document.querySelector('.dd_custom_login_success_containor .promo-offer').classList.add("hide");
           dd_custom_login_change_step('dd_custom_login_success_containor');
           if(typeof webengage != 'undefined'){
                webengage.user.login(phone);
                webengage.user.setAttribute({phone: phone});
                webengage.track("Web Login", {
                  method: "otp",
                  source: "website"
                });
            }
           setTimeout(() => {
            window.location = data.login_url
           }, 1500);
        }else{
          dd_custom_login_user_mobile_number_detail_sec_ele.value = `+91${dd_custom_login_user_mobile_number}`; 
          dd_custom_login_change_step('dd_custom_login_customer_detail_containor');
        }
      }else{
        dd_custom_login_show_msg(data.message,false);
      }
    } catch (e) {
      return { success: false, message: e.message };
    }
  }

  window.dd_login_verify_otp=()=>{
    let dd_login_otp_unfilled_box = document.querySelector(".dd_custom_login_otp_input_box[value='']");
    if(dd_login_otp_unfilled_box){
      dd_custom_login_show_msg('Please enter OTP',false);
      return;
    }
    dd_loading_bar_spinner.classList.remove('dd_hide_loading');
    let dd_user_otp = Array.from(dd_custom_login_otp_input_boxes).map(input => input.value).join('');
    dd_login_verify_otp_fun(`+91${dd_custom_login_user_mobile_number}`,dd_user_otp,dd_custom_login_shop_domain.dataset.domain,`https://${__st.pageurl}`);
  }
  
  async function dd_custom_login_create_customer(dd_create_customer_payload) {
    try {
      const res = await fetch("https://api.kalkifashion.com/kalki-api-new/customer.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dd_create_customer_payload )
      });
      const data = await res.json();
      if(data.success){
          document.querySelector('.dd_custom_login_success_containor .success-subtitle').classList.add("hide");
          dd_custom_login_change_step('dd_custom_login_success_containor');

          if(typeof webengage !== 'undefined') {
            console.log("Webenge starts");
            webengage.user.login(dd_create_customer_payload.phone);
            webengage.user.setAttribute({
              first_name: dd_create_customer_payload.first_name,
              last_name: dd_create_customer_payload.last_name,
              email: dd_create_customer_payload.email,
              phone: dd_create_customer_payload.phone,
              dob: dd_create_customer_payload.dob,
              gender: dd_create_customer_payload.gender?.toLowerCase(),
              anniversary_date: dd_create_customer_payload.aniiversary,
              accepts_marketing: dd_create_customer_payload.subscription_newsletter?dd_create_customer_payload.subscription_newsletter:false
            });
            webengage.track("Web Customer register", {
              source: "website",
              method: "otp"
            });
            console.log("Webenge ends");
          }
          dd_new_customer_login_url = data.login_url;
      }else{
        dd_custom_login_show_msg(data.errors[0].message,false);
      }
      return data;
    } catch (e) {
      return { success: false, message: e.message };
    }
  } 

   window.dd_customer_detail_form_submit = (e)=>{
    e.preventDefault();

    dd_custom_otp_user_names.forEach((user_name_input)=>{dd_validation_for_username(user_name_input)});
    dd_validation_for_email();
    dd_validation_for_anniversary();
    dd_validation_for_dob();
    dd_validation_for_gender();
    dd_validation_for_marketing_checkbox();
    let dd_otp_detail_form_error_active = document.querySelector('.dd_otp_detail_form_error_active');
    if(dd_otp_detail_form_error_active){
        dd_otp_detail_form_error_active.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    const dd_customer_detail_form = e.target;
    if (dd_customer_detail_form.checkValidity() && !dd_otp_detail_form_error_active) {
      const formData = new FormData(dd_customer_detail_form);
      const dd_create_customer_payload = Object.fromEntries(formData);
      const dd_newslater_marketting = document.querySelector('.cust_popup_container #marketing');
      if(dd_newslater_marketting && dd_newslater_marketting.checked){
        dd_create_customer_payload.subscription_newsletter = true;
      }
      dd_custom_login_create_customer(dd_create_customer_payload);
    }
  }


  window.dd_custom_login_otp_box_events=()=>{
    dd_custom_login_otp_input_boxes.forEach((dd_otp_input_box, index) => {
      dd_otp_input_box.addEventListener("input", (e) => {
        e.target.value = e.target.value.replace(/[^0-9]/g, "");
        e.target.setAttribute("value", e.target.value); 
        if (e.target.value.length === 1 && index < dd_custom_login_otp_input_boxes.length - 1) {
          dd_custom_login_otp_input_boxes[index + 1].focus();
        }
        const dd_is_all_the_opt_box_are_filled = [...dd_custom_login_otp_input_boxes].every(inp => inp.value.length === 1);
        if(dd_is_all_the_opt_box_are_filled){dd_login_verify_otp()}
      });
      dd_otp_input_box.addEventListener("keydown", (e) => {
        if (e.key === "Backspace" && !e.target.value && index > 0) {
          dd_custom_login_otp_input_boxes[index - 1].focus();
        }
      });
    });
  }
  document.querySelectorAll('a[href="/account/login"]').forEach(dd_account_icon=>{
    dd_account_icon.addEventListener('click',e=>{
      e.stopImmediatePropagation();
      e.preventDefault();
      if(!__st.pageurl.includes('account/login')){
       dd_login_containor.classList.remove('dd_hide_custom_login_popup');
       dd_custom_login_popup_overlap.classList.remove('dd_hide_custom_login_popup');
       document.body.classList.add('dd_custom_popup_body_overflow_hidden');
      }
    });
  });

  dd_custom_login_otp_box_events();


 window.dd_copy_discount_code = (discount_code_btn) => {
  let dd_discount_code = discount_code_btn.dataset.discount;

  navigator.clipboard.writeText(dd_discount_code).then(() => {
    let popup = document.createElement("div");
    popup.innerText = "Copied!";
    popup.style.position = "absolute";
    popup.style.background = "#333";
    popup.style.color = "#fff";
    popup.style.padding = "4px 8px";
    popup.style.fontSize = "12px";
    popup.style.borderRadius = "4px";
    popup.style.whiteSpace = "nowrap";
    popup.style.zIndex = "9999";
    popup.style.top = (discount_code_btn.offsetTop + discount_code_btn.offsetHeight + 5) + "px";
    popup.style.left = discount_code_btn.offsetLeft + "px";

    discount_code_btn.parentElement.appendChild(popup);

    setTimeout(() => {
      popup.remove();
    }, 2000);
  });
};


  function dd_validation_for_username(user_name_input) {
    let dd_error_span_ele = user_name_input.closest('.login_inputblock').querySelector('.dd_error_msg_detail_form');
    let user_name_value = user_name_input.value.trim();
    let dd_error_msg = '';
    if(!user_name_value)dd_error_msg = 'Name is required.';
    else if (user_name_value.length < 2) dd_error_msg = "Name must be at least 2 characters..";
    else if (!/^[A-Za-zÀ-ÖØ-öø-ÿ]/.test(user_name_value)) dd_error_msg = "Please start with a letter.";
    else if (/[^A-Za-zÀ-ÖØ-öø-ÿ '\-]/.test(user_name_value)) dd_error_msg = "Only letters allowed.";
    if(dd_error_msg){
       dd_error_span_ele.innerText = dd_error_msg;
       dd_error_span_ele.classList.add('dd_otp_detail_form_error_active');
    }else{
      dd_error_span_ele.innerText = '';
      dd_error_span_ele.classList.remove('dd_otp_detail_form_error_active');
    }
  }

  function dd_validation_for_email() { 
    let dd_error_span_ele = dd_otp_detail_email_input.closest('.login_inputblock').querySelector('.dd_error_msg_detail_form');
    const dd_email_value = dd_otp_detail_email_input.value.trim();
    let dd_error_msg = '';
    if (!dd_email_value) dd_error_msg = "Email is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(dd_email_value)) dd_error_msg = "Enter a valid email.";
     if(dd_error_msg){
       dd_error_span_ele.innerText = dd_error_msg;
       dd_error_span_ele.classList.add('dd_otp_detail_form_error_active');
    }else{
      dd_error_span_ele.innerText = '';
      dd_error_span_ele.classList.remove('dd_otp_detail_form_error_active');
    }
  }

 function dd_validation_for_anniversary(){
     const dd_error_span_ele = dd_anniversary_input.closest('.custom_field').querySelector('.dd_error_msg_detail_form');
     if(dd_anniversary_input.validationMessage!=''){
          dd_error_span_ele.innerText = "Please enter a valid date.";
          dd_error_span_ele.classList.add('dd_otp_detail_form_error_active');
      }else{
          dd_error_span_ele.innerText = "";
          dd_error_span_ele.classList.remove('dd_otp_detail_form_error_active');
      }
  }

  function dd_validation_for_dob() {
    const dd_error_span_ele = dd_dob_input.closest('.custom_field').querySelector('.dd_error_msg_detail_form');

    if (!dd_dob_input.value) {
      dd_error_span_ele.innerText = "Please enter your date of birth.";
      dd_error_span_ele.classList.add('dd_otp_detail_form_error_active');
    } else {
      const dobDate = new Date(dd_dob_input.value);
      const minAgeDate = new Date();
      minAgeDate.setFullYear(minAgeDate.getFullYear() - 18);

      if (dobDate > minAgeDate) {
        dd_error_span_ele.innerText = "You must be at least 18 years old.";
        dd_error_span_ele.classList.add('dd_otp_detail_form_error_active');
      } else {
        dd_error_span_ele.innerText = "";
        dd_error_span_ele.classList.remove('dd_otp_detail_form_error_active');
      }
    }
  }

  function dd_validation_for_gender() {
    const dd_error_span_ele = dd_gender_input.closest('.custom_field').querySelector('.dd_error_msg_detail_form');
    if (!dd_gender_input.value) {
      dd_error_span_ele.innerText = "Please select your gender.";
      dd_error_span_ele.classList.add('dd_otp_detail_form_error_active');
    } else {
      dd_error_span_ele.innerText = "";
      dd_error_span_ele.classList.remove('dd_otp_detail_form_error_active');
    }
 }

 function dd_validation_for_marketing_checkbox() {
  if (!dd_marketing_checkbox.checked) {
    dd_marketing_checkbox.closest('.update-checkbox-wrapper').querySelector('.dd_error_msg_detail_form').classList.add('dd_marketing_checkbox_error');
  } else {
     dd_marketing_checkbox.closest('.update-checkbox-wrapper').querySelector('.dd_error_msg_detail_form').classList.remove('dd_marketing_checkbox_error');
  }
}


  dd_custom_otp_user_names.forEach((user_name_input)=>{
    user_name_input.addEventListener('blur',()=>dd_validation_for_username(user_name_input));
    user_name_input.addEventListener('focus', () => {
      const dd_error_span_ele = user_name_input.closest('.login_inputblock').querySelector('.dd_error_msg_detail_form');
      dd_error_span_ele.innerText = '';
      dd_error_span_ele.classList.remove('dd_otp_detail_form_error_active');
    });
  })
  dd_otp_detail_email_input.addEventListener("blur", () => dd_validation_for_email());
  dd_otp_detail_email_input.addEventListener("focus", () => {
    const dd_error_span_ele = dd_otp_detail_email_input.closest('.login_inputblock').querySelector('.dd_error_msg_detail_form');
    dd_error_span_ele.innerText = '';
    dd_error_span_ele.classList.remove('dd_otp_detail_form_error_active');
  });

  dd_anniversary_input.addEventListener('blur', () => {
   dd_validation_for_anniversary();
  });

  dd_anniversary_input.addEventListener('focus', () => {
    const dd_error_span_ele = dd_anniversary_input.closest('.custom_field').querySelector('.dd_error_msg_detail_form');
    dd_error_span_ele.innerText = "";
    dd_error_span_ele.classList.remove('dd_otp_detail_form_error_active');
  });


  dd_dob_input.addEventListener('blur', dd_validation_for_dob);
  dd_dob_input.addEventListener('focus', () => {
    const dd_error_span_ele = dd_dob_input.closest('.custom_field').querySelector('.dd_error_msg_detail_form');
    dd_error_span_ele.innerText = "";
    dd_error_span_ele.classList.remove('dd_otp_detail_form_error_active');
  });


dd_gender_input.addEventListener('blur', dd_validation_for_gender);
dd_gender_input.addEventListener('focus', () => {
  const dd_error_span_ele = dd_gender_input.closest('.custom_field').querySelector('.dd_error_msg_detail_form');
  dd_error_span_ele.innerText = "";
  dd_error_span_ele.classList.remove('dd_otp_detail_form_error_active');
});

dd_marketing_checkbox.addEventListener('change', dd_validation_for_marketing_checkbox);
dd_marketing_checkbox.addEventListener('blur', dd_validation_for_marketing_checkbox);

}